/* tslint:disable */

/**
 */
export class Warning {
    Message?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/warning.ts